namespace TabAurous.Retail {
    export namespace GiftVoucherAllocateDetailsService {
        export const baseUrl = 'Retail/GiftVoucherAllocateDetails';

        export declare function Create(request: Serenity.SaveRequest<GiftVoucherAllocateDetailsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<GiftVoucherAllocateDetailsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<GiftVoucherAllocateDetailsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<GiftVoucherAllocateDetailsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Retail/GiftVoucherAllocateDetails/Create",
            Update = "Retail/GiftVoucherAllocateDetails/Update",
            Delete = "Retail/GiftVoucherAllocateDetails/Delete",
            Retrieve = "Retail/GiftVoucherAllocateDetails/Retrieve",
            List = "Retail/GiftVoucherAllocateDetails/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>GiftVoucherAllocateDetailsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
